import { Star } from "lucide-react";

export default function Stars({ value = 0, size = 14, onRate, className = "" }) {
  const interactive = typeof onRate === "function";
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`}>
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = value >= i - 0.25;
        return (
          <Star
            key={i}
            style={{ width: size, height: size }}
            onClick={interactive ? () => onRate(i) : undefined}
            data-testid={interactive ? `star-${i}` : undefined}
            className={`${filled ? "fill-primary text-primary" : "text-muted-foreground"} ${interactive ? "cursor-pointer hover:scale-110 transition-transform" : ""}`}
          />
        );
      })}
    </div>
  );
}
